// Document ready
document.addEventListener("DOMContentLoaded", function () {
  submitFormOnFakeButton();
});

//Submit form with fake button
function submitFormOnFakeButton() {
  // Odeslání formu přes JS
  $("#submitButton, .submitButton").click(function () {
    if ($(this).hasClass("disabled")) {
      return false;
    }
    $(this)
      .parents("form")
      .submit();
  });
}

jQuery(".gallery .wp-caption-text").each(function () {
  jQuery(this).parents(".gallery-item").find("a").data("caption", jQuery(this).text());
});





$('.download-file .base-subheading').matchHeight();